import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { waLink, waLinkProps } from '../mock';
import WhatsAppIcon from './WhatsAppIcon';
import FooterEmblem3D from './FooterEmblem3D';
import { trackWhatsAppClick } from '../lib/analytics';

const AboutContact = () => (
  <>
    <section id="contacto" className="q-contact" data-testid="contacto-section">
      <div className="q-contact__inner">
        <span className="q-section__eyebrow">03 — Contacto</span>
        <h2 className="q-contact__title">Hablemos de tu próxima pieza</h2>
        <p className="q-contact__sub">
          Atención directa y personal. Cotiza, pregunta o aparta por WhatsApp.
        </p>
        <a
          href={waLink('Hola QUINLATE, quiero hablar sobre una pieza.')}
          {...waLinkProps}
          className="q-btn q-btn--gold q-btn--lg q-btn--wa"
          data-testid="contact-whatsapp-btn"
          aria-label="Cotizar por WhatsApp"
          onClick={() => trackWhatsAppClick('contact_footer')}
        >
          <WhatsAppIcon size={26} />
        </a>
        <div className="q-contact__socials">
          <a href="https://www.instagram.com/quinlate.joyeros/" target="_blank" rel="noopener noreferrer" className="q-contact__social" data-testid="social-instagram">
            <Instagram size={18} strokeWidth={1.5} /> Instagram
          </a>
        </div>
      </div>
      <footer className="q-footer" data-testid="footer">
        <div className="q-footer__brand-wrapper">
          <FooterEmblem3D />
          <span className="q-footer__brand">QUINLATE</span>
        </div>
        <div className="q-footer__meta">
          <span className="q-footer__copy">© {new Date().getFullYear()} QUINLATE — Pureza real. Oro de ley.</span>
          <Link to="/privacidad" className="q-footer__privacy" data-testid="footer-privacy-link">
            Aviso de Privacidad
          </Link>
        </div>
      </footer>
    </section>
  </>
);

export default AboutContact;
